<script>
export default {
  props: {
    value: Object,
  },
}
</script>

<template>
  <i18n :path="value.event" tag="div">
    <template #form>
      <router-link :to="{ name: 'form-submit-mutate', params: { id: value.data.submit } }">
        {{ value.data.title }}
      </router-link>
    </template>
  </i18n>
</template>
